import { ILinkedCardData } from '../../../../types/redux/paymentMethods';
import { IWidgetLinkedCardResponse } from '../../../../repositories/billing-payments/entities/PaymentWidget/WidgetLinkedCardResponse';
import { mapCardType } from './mapCardType';
import { formatCardNumber } from './formatCardNumber';
import { mapBankType } from './mapBankType';

export const mapLinkedCard = (card: IWidgetLinkedCardResponse | undefined): ILinkedCardData | null => {
  if (!card) {
    return null;
  }

  const { type, bankType, last4 } = card;

  const id = card.id as number;

  return {
    id,
    cardType: mapCardType(type),
    cardNumber: formatCardNumber(last4),
    bankType: mapBankType(bankType),
  };
};
